/*
  Zoohaven: henter det tunge menyinnholdet ved behov (v2, sept 2026).

  HTML-en som sendes med siden inneholder hele menyen som tekst, og
  underkategoriene med ikoner. Menyen er altsa komplett og visuell i det
  oyeblikket den apnes. Det som hentes etterpa er bare det store panelet —
  kategoribildene, produktkortene og «Mest solgte».

  Viktig endring i v2 (fikser dobbelttrykk pa iPhone):
    Forhandshenting (hover, fokus, finger ned) rorer ALDRI DOM-en. Den
    legger bare svaret i cache. Safari pa iOS avbryter et trykk dersom
    innholdet under fingeren endrer seg mens trykket pagar («content
    observation») — og det var akkurat det som skjedde nar Hund og Katt
    allerede la ferdig i cache: panelet ble byttet ut i samme oyeblikk som
    fingeren traff skjermen, og klikket forsvant.

    Innholdet settes forst inn etter at <details> faktisk er apnet, og pa
    berøringsskjermer forst etter at skuffen har glidd ferdig inn, slik at
    parsingen av produktkortene ikke hakker i animasjonen.

  Feiler hentingen, blir tekstversjonen staende. Menyen mister bildene i
  panelet, men ingenting slutter a virke.

  Containere merkes i Liquid med:
    data-zh-menu-lazy
    data-zh-menu-handle="<samling-handle>"
    data-zh-menu-view="zhmenu" | "zhmenum"
*/
(function () {
  'use strict';

  var cache = new Map();          // url -> Promise<string>
  var state = new WeakMap();      // container -> 'loaded' | 'empty' | 'skip'
  var MAX_PREFETCH = 2;
  var MAX_WARM_ICONS = 60;

  // Berøringsskjerm: vent til skuffen har glidd inn for vi bytter innhold.
  // Temaet legger pa .active etter 100 ms og animerer i ~400 ms.
  var isTouch = window.matchMedia
    ? window.matchMedia('(hover: none), (pointer: coarse)').matches
    : 'ontouchstart' in window;
  var INSERT_DELAY_MS = isTouch ? 450 : 0;

  function saveData() {
    var c = navigator.connection;
    if (!c) return false;
    if (c.saveData) return true;
    return c.effectiveType === 'slow-2g' || c.effectiveType === '2g';
  }

  function fragmentUrl(handle, view) {
    var root = '/';
    if (window.Shopify && Shopify.routes && Shopify.routes.root) root = Shopify.routes.root;
    return root.replace(/\/$/, '') + '/collections/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(view);
  }

  function urlFor(el) {
    var handle = el.getAttribute('data-zh-menu-handle');
    var view = el.getAttribute('data-zh-menu-view');
    if (!handle || !view) return null;
    return fragmentUrl(handle, view);
  }

  // Bare nettverk og cache. Ingen DOM-endringer her — se kommentaren over.
  function get(url) {
    var pending = cache.get(url);
    if (!pending) {
      pending = fetch(url, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      });
      pending.catch(function () { cache.delete(url); });
      cache.set(url, pending);
    }
    return pending;
  }

  function prefetch(el) {
    if (!el || state.get(el)) return;
    var url = urlFor(el);
    if (url) get(url).catch(function () {});
  }

  function prefetchWithin(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    if (root.matches && root.matches('[data-zh-menu-lazy]')) prefetch(root);
    var nodes = root.querySelectorAll('[data-zh-menu-lazy]');
    for (var i = 0; i < nodes.length; i++) prefetch(nodes[i]);
  }

  // Hvilken underkategori som er valgt i venstrekolonnen (desktop), slik at
  // den kan velges igjen etter at innholdet er byttet ut.
  function selectedIndex(el) {
    var toggles = el.querySelectorAll('.menu-sidebar__toggle');
    for (var i = 0; i < toggles.length; i++) {
      if (toggles[i].classList.contains('is-visible')) return i;
    }
    return -1;
  }

  function restoreIndex(el, index) {
    if (index < 1) return;
    var toggles = el.querySelectorAll('.menu-sidebar__toggle');
    if (toggles[index] && !toggles[index].classList.contains('is-visible')) {
      toggles[index].click();
    }
  }

  function stillOpen(el) {
    var d = el.closest('details');
    return !d || d.open;
  }

  // Selve innsettingen. Kjøres alltid asynkront, aldri inne i et
  // pekerhendelses-kall, og bare mens menyen fortsatt er apen.
  function insert(el, html) {
    if (state.get(el)) return;
    if (!stillOpen(el)) return; // lukket igjen for vi rakk a sette inn — prov neste gang

    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var index = selectedIndex(el);

    if (el.replaceChildren) el.replaceChildren(tpl.content);
    else el.innerHTML = html;
    state.set(el, 'loaded');
    el.setAttribute('data-zh-menu-state', 'loaded');
    restoreIndex(el, index);
    el.dispatchEvent(new CustomEvent('zh:menu-loaded', { bubbles: true }));
  }

  function load(el) {
    if (!el || state.get(el)) return;
    var url = urlFor(el);
    if (!url) {
      state.set(el, 'skip');
      return;
    }

    var openedAt = Date.now();
    get(url)
      .then(function (html) {
        if (!html || !html.trim()) {
          state.set(el, 'empty');
          return;
        }
        var wait = Math.max(0, INSERT_DELAY_MS - (Date.now() - openedAt));
        setTimeout(function () {
          requestAnimationFrame(function () { insert(el, html); });
        }, wait);
      })
      .catch(function () { /* tekstversjonen blir staende */ });
  }

  function loadWithin(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    if (root.matches && root.matches('[data-zh-menu-lazy]')) load(root);
    var nodes = root.querySelectorAll('[data-zh-menu-lazy]');
    for (var i = 0; i < nodes.length; i++) load(nodes[i]);
  }

  // toggle bobler ikke, men capture-fasen fanger det likevel — og fanger
  // ogsa menyer som legges til i DOM-en senere. Bare her rorer vi DOM-en.
  document.addEventListener(
    'toggle',
    function (event) {
      var d = event.target;
      if (!d || d.tagName !== 'DETAILS' || !d.open) return;
      loadWithin(d);
    },
    true
  );

  // Start hentingen sa tidlig vi kan — men bare til cache.
  ['pointerenter', 'pointerdown', 'focusin'].forEach(function (name) {
    document.addEventListener(
      name,
      function (event) {
        var t = event.target;
        if (!t || typeof t.closest !== 'function') return;
        var d = t.closest('details');
        if (d) prefetchWithin(d);
      },
      true
    );
  });

  // Nar siden ellers er ferdig: varm opp menyikonene og hent de to forste
  // kategoriene til cache. Droppes pa sparemodus og trege forbindelser.
  function whenIdle(fn) {
    if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: 4000 });
    else setTimeout(fn, 2000);
  }

  function warmUp() {
    if (saveData()) return;

    var containers = document.querySelectorAll('[data-zh-menu-lazy]');
    if (!containers.length) return;

    var seen = {};
    var count = 0;
    for (var i = 0; i < containers.length && count < MAX_WARM_ICONS; i++) {
      var imgs = containers[i].querySelectorAll('img[src]');
      for (var j = 0; j < imgs.length && count < MAX_WARM_ICONS; j++) {
        var src = imgs[j].currentSrc || imgs[j].src;
        if (!src || seen[src]) continue;
        seen[src] = true;
        count++;
        var warm = new Image();
        warm.decoding = 'async';
        if ('fetchPriority' in warm) warm.fetchPriority = 'low';
        warm.src = src;
      }
    }

    var wide = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
    var view = wide ? 'zhmenu' : 'zhmenum';
    var picked = 0;
    for (var k = 0; k < containers.length && picked < MAX_PREFETCH; k++) {
      var el = containers[k];
      if (el.getAttribute('data-zh-menu-view') !== view) continue;
      if (state.get(el)) continue;
      var url = urlFor(el);
      if (!url) continue;
      picked++;
      get(url).catch(function () {});
    }
  }

  if (document.readyState === 'complete') whenIdle(warmUp);
  else window.addEventListener('load', function () { whenIdle(warmUp); });
})();
